module.exports = __webpack_public_path__ + "static/media/logo.06288d9b.png";